import { render, staticRenderFns } from "./AboutPage4.vue?vue&type=template&id=a8431290&scoped=true"
import script from "./AboutPage4.vue?vue&type=script&lang=js"
export * from "./AboutPage4.vue?vue&type=script&lang=js"
import style0 from "./AboutPage4.vue?vue&type=style&index=0&id=a8431290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8431290",
  null
  
)

export default component.exports